export const ENCOUNTER_PATH = 'atendimento'
export const HISTORIC_PATH = 'historico'
export const DASHBOARD_PATH = 'dashboard'
export const DEFAULT_PATH = 'dashboard'
export const TIMELINE_PATH = 'timeline'
export const TIMELINE_LABORATORY_PATH = 'visao-laboratorio'
export const TIMELINE_GENERAL_PATH = 'visao-geral'
export const TIMELINE_MATERNAL_INFANT_PATH = 'visao-materno-infantil'
export const TIMELINE_RADIOLOGY_PATH = 'visao-radiologia'
export const TIMELINE_ONCOLOGY_PATH = 'visao-oncologia'
export const SEARCH_PATIENT_PATH = 'pesquisar-paciente'
export const DIAGNOSES_PATH = 'diagnosticos'
export const FETAL_DIAGNOSES_PATH = 'diagnosticos-fetais'
export const ALLERGIES_PATH = 'alergias'
export const ANALYTICAL_MODELS_PATH = 'modelos-analiticos'
